var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M39.9 46.1H80M39.9 32.6h17.8M106.6 54.8V37l-19-17.4H30.3c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M87.6 19.7V37h19M115.3 103H81.6c-2.8 0-5.1-2.3-5.1-5.1V69c0-2.8 2.3-5.1 5.1-5.1h33.7c2.8 0 5.1 2.3 5.1 5.1v28.8c0 2.9-2.3 5.2-5.1 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M87.8 77.2L94.1 90l4.3-12.6M109.1 77.2L102.8 90l-4.4-12.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.0f8daf768aa25f481be6e559f6575bdc.svg";
export { ForwardRef as ReactComponent };